import { SelectAsyncInput } from '@core/components/Select';
import { parseHeaderForLinks } from '@core/util';
import { clienteApi } from 'app/services/api/clienteApi';
import React from 'react';

const SelectCliente = ({
  id,
  name,
  label,
  value,
  touched,
  error,
  onBlur,
  onChange,
  required,
  autoFocus,
  disabled,
  multiple,
  getOptionDisabled,
}) => {
  return (
    <SelectAsyncInput
      id={id}
      multiple={multiple}
      autoFocus={autoFocus}
      required={required}
      disabled={disabled}
      name={name}
      label={label}
      value={value}
      onChange={(event, valor) => {
        onChange({
          target: {
            id,
            value: valor,
          },
        });
      }}
      touched={touched}
      error={error}
      onBlur={onBlur}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => {
        return option.nome;
      }}
      getOptionDisabled={getOptionDisabled}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }
        const response = await clienteApi.pesquisar({
          size: 100,
          sort: 'pessoa.nome',
          page: next,
          q: query,
        });
        const links = parseHeaderForLinks(response.headers.link);
        const totalItems = response.headers['x-total-count'];
        const data = response?.data || [];

        return { data, nextPage: links.next, totalItems };
      }}
      fetchOnFocus
    />
  );
};

export default SelectCliente;
